import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createVNode as _createVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-065a09f2")

_pushScopeId("data-v-065a09f2")
const _hoisted_1 = {
  class: "swiperContainer",
  ref: "swiperContainer"
}
const _hoisted_2 = {
  key: 0,
  class: "swiper-pagination",
  ref: "swiperPagination"
}
const _hoisted_3 = {
  key: 0,
  class: "swiper-button-next",
  ref: "swiper_next"
}
const _hoisted_4 = {
  key: 1,
  class: "swiper-button-prev",
  ref: "swiper_prev"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock("div", {
    class: ["w-100", {'swiper_with_arrow' : _ctx.arrow}]
  }, [
    _createVNode("div", _hoisted_1, [
      (_ctx.showPagination && _ctx.canPaginate)
        ? (_openBlock(), _createBlock("div", _hoisted_2, null, 512))
        : _createCommentVNode("", true),
      _createVNode("div", {
        class: ["swiper-wrapper", {'with_arrow' : _ctx.arrow}]
      }, [
        _renderSlot(_ctx.$slots, "default", {}, undefined, true)
      ], 2)
    ], 512),
    (_ctx.arrow)
      ? (_openBlock(), _createBlock("div", _hoisted_3, null, 512))
      : _createCommentVNode("", true),
    (_ctx.arrow)
      ? (_openBlock(), _createBlock("div", _hoisted_4, null, 512))
      : _createCommentVNode("", true)
  ], 2))
})